import { render, staticRenderFns } from "./KeShangSelect1.vue?vue&type=template&id=18a56f14"
import script from "./KeShangSelect1.vue?vue&type=script&lang=ts"
export * from "./KeShangSelect1.vue?vue&type=script&lang=ts"
import style0 from "./KeShangSelect1.vue?vue&type=style&index=0&id=18a56f14&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports
import {QPullToRefresh,QHeader,QToolbar,QItem,QAvatar,QBtn,QIcon,QSpace,QBtnDropdown,QList,QItemSection,QFooter,QTabs,QTab,QDialog,QCard,QLayout,QPageContainer,QTabPanels,QTabPanel,QPage} from 'quasar'
component.options.components = Object.assign(Object.create(component.options.components || null), component.options.components || {}, {QPullToRefresh,QHeader,QToolbar,QItem,QAvatar,QBtn,QIcon,QSpace,QBtnDropdown,QList,QItemSection,QFooter,QTabs,QTab,QDialog,QCard,QLayout,QPageContainer,QTabPanels,QTabPanel,QPage})
